module.exports = __webpack_public_path__ + "static/media/송라산.da793581.jpg";